import { render, staticRenderFns } from "./CustomActivityCard.vue?vue&type=template&id=67137050&scoped=true&"
import script from "./CustomActivityCard.vue?vue&type=script&lang=js&"
export * from "./CustomActivityCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomActivityCard.vue?vue&type=style&index=0&id=67137050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67137050",
  null
  
)

export default component.exports